import React from 'react';
import { IMetadata } from 'common/schema/metadata/Metadata';
import {
  OutputTargetType,
  StandardOutputKey
} from 'common/schema/output/Output';
import { IWidgetInput } from 'common/schema/widget/input/WidgetInput';
import { Trans, useTranslation } from 'react-i18next';
import { useSharedProcedure } from '../../helper/shared/useSharedProcedure';

/**
 * Ottiene il messaggio di help "forzato" per le eMail principali dell'istanza,
 * specificando che deve essere inserita una PEO (non una PEC) .
 *
 * Funziona sia lato backend che lato frontend.
 */
export function useMailHelp(metadata: IMetadata) {
  const procedure = useSharedProcedure();
  const authorMail = procedure.outputs.find(
    o =>
      o.key === StandardOutputKey.AuthorMail &&
      o.common &&
      o.target === OutputTargetType.Document
  );

  if (!authorMail || authorMail.metadataId !== metadata.id) {
    return null;
  }

  return {
    extra: (
      <Trans key="widgets.input-email.author-mail-peo-warning">
        Inserire una mail di posta elettronica ordinaria.
      </Trans>
    )
  };
}
